import React, { Component } from 'react';

import Objectifs from '../../../components/Objectifs';
import ProjectContent from '../../../components/ProjectContent';
import '../../../css/views/project.css';

export default class Yanascope extends Component {
	render() {
		const { img, objectives } = this.props;
		return (
			<div>
				<ProjectContent altTitle="Les enjeux de l'application mobile">
					<p className="text-detail">
						Les attentes des consommateurs en matière d’événements culturels ont
						évolué. <strong>Ils souhaitent accéder à ces événements au bon endroit, au
						bon moment et de manière personnalisée</strong>.<br/> De l’autre côté, l’offre
						loisirs et artistique n’a jamais été aussi riche, et rencontrer sa
						cible peut s’avérer problématique.
					</p>
					<p className="text-detail left">Les utilisateurs attendent :<br/></p>
					<ul className="text-detail left">
						<li>- une information fiable, factuelle, et en temps réel</li>
						<li>- une information utile, claire, simple et compréhensible</li>
					</ul>
					<p className="text-detail">
						Tandis que les professionnels du secteur recherchent <strong>une régie
						publicitaire pratique</strong> qui facilite leur communication.
						L’application Yanascope permet de répondre à ces besoins en
						proposant la bonne information, à la bonne personne et au bon
						endroit.
					</p>
				</ProjectContent>

				<Objectifs src={img} objectives={objectives} extraClassName="darkBackground"/>

				<ProjectContent
					mecanique
					subtitle="Yanascope, les meilleures adresses et les meilleurs plans à partager entre amis."
				>
					<p className="text-detail">
						Grâce à la création d'un compte et la personnalisation de son
						profil, <strong>Yanascope propose les meilleurs plans sorties en fonction de
						ses centres d'intérêts</strong>.<br/> L'application couvre l’ensemble de l’univers
						des sorties : une base de données restaurants, bars, club, salle de
						spectacles et activités référencés couvrant le territoire de la
						Guyane.<br/>
						La navigation se fait par géolocalisation. L'utilisateur a ainsi
						accès à <strong>des fiches complètes avec toutes les informations sur les
						lieux et évènements</strong> : présentation, infos pratiques, photos et avis
						des utilisateurs. Ces derniers peuvent partager les bons plans entre
						eux et recevoir des alertes: notification, calendrier, rappels.
					</p>
				</ProjectContent>

				<ProjectContent altTitle="Identité graphique et ergonomie">
					...
				</ProjectContent>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projet/fiches/Yanascope.js